import { createAsyncThunk } from "@reduxjs/toolkit";
import { usersAPI } from "../api/usersApi";

export const getUsersLookup = createAsyncThunk(
  'admin/getUsersLookup', async () => {
    try {
      const response = await usersAPI.getUsersLookup();
      return response.data;
    } catch (error: any) {
      return error
    }
  }
)
